import { defineSlotRecipe } from '@chakra-ui/react'
import { radioGroupAnatomy } from '@chakra-ui/react/anatomy'

export const radioSlotRecipe = defineSlotRecipe({
    slots: radioGroupAnatomy.keys(),
    variants: {
        variant: {
            gigiOutline: {
                itemControl: {
                    width: '20px',
                    height: '20px',
                    borderWidth: '2px',
                    _light: {
                        borderColor: 'var(--chakra-colors-dark-700)',
                        _hover: {
                            backgroundColor: 'var(--chakra-colors-gray-100)',
                        },
                    },
                    _dark: {
                        borderColor: 'var(--chakra-colors-gray-100)',
                        opacity: 0.16,
                        _hover: {
                            backgroundColor: 'var(--chakra-colors-gray-100)',
                        },
                    },
                    _checked: {
                        _light: {
                            backgroundColor: 'var(--chakra-colors-gray-100)',
                            borderColor: 'var(--chakra-colors-dark-700)',
                            '& .dot': {
                                color: 'var(--chakra-colors-dark-700)',
                                scale: 0.63,
                            },
                            _hover: {
                                backgroundColor: 'var(--chakra-colors-gray-100)',
                                borderColor: 'var(--chakra-colors-dark-700)',
                            },
                        },
                        _dark: {
                            backgroundColor: 'var(--chakra-colors-dark-700)',
                            borderColor: 'var(--chakra-colors-gray-100)',
                            opacity: 1,
                            '& .dot': {
                                color: 'var(--chakra-colors-gray-100)',
                                scale: 0.63,
                            },
                            _hover: {
                                backgroundColor: 'var(--chakra-colors-dark-700)',
                                borderColor: 'var(--chakra-colors-gray-100)',
                            },
                        },
                    },
                },
                label: {
                    _light: {
                        color: 'var(--chakra-colors-dark-700)',
                    },
                    fontSize: '14px',
                    letterSpacing: '0.25px',
                    marginTop: '1px',
                    _disabled: {
                        opacity: 1,
                    },
                },
            },
        },
    },
})
